import { useMemo } from "react";
import useNumberFormatter from "hooks/useNumberFormatter";
import useMergeProps from "hooks/useMergeProps";

const DEFAULT_PROPS: UseNumberSeparatorsProps = {
  grouping: false,
};

interface UseNumberSeparatorsProps {
  grouping?: boolean;
}

/**
 * Locale-aware separator props for numeric inputs;
 * accepts "." and "," as decimal input unless grouping claims it for the thousand separator
 */
function useNumberSeparators(props?: UseNumberSeparatorsProps) {
  const { grouping } = useMergeProps(DEFAULT_PROPS, props);
  const formatter = useNumberFormatter();

  return useMemo(() => {
    // 7 digits so locales with minimumGroupingDigits: 2 (e.g. es) still emit a group part
    const parts = formatter.formatToParts(1000000.1);
    const group = parts.find((part) => part.type === "group")?.value ?? ",";
    const decimal = parts.find((part) => part.type === "decimal")?.value ?? ".";

    return {
      thousandSeparator: grouping ? group : false,
      decimalSeparator: decimal,
      allowedDecimalSeparators: Array.from(new Set([decimal, ".", ","])).filter(
        (separator) => !grouping || separator !== group
      ),
    };
  }, [formatter, grouping]);
}

export default useNumberSeparators;
